import { useCallback } from 'react';
import * as React from 'react';
import { FormCheck } from 'react-bootstrap';

import classes from './checkbox.module.scss';

export type CheckboxProps = React.ComponentProps<FormCheck> & {
  onCheckedChange?: (checked: boolean) => void;
};

export const CheckBox: React.FC<CheckboxProps> = ({
  checked = false,
  children,
  custom = true,
  name,
  onChange,
  onCheckedChange,
  ...props
}) => {
  const onChangeCallback = useCallback(
    (event: React.ChangeEvent<HTMLInputElement>) => {
      if (onChange) {
        onChange(event);
      }

      if (onCheckedChange) {
        onCheckedChange(event.target.checked);
      }
    },
    [onChange, onCheckedChange]
  );

  return (
    <FormCheck custom={custom} {...props}>
      <FormCheck.Input
        checked={checked}
        name={name}
        type={'checkbox'}
        onChange={onChangeCallback}
      />

      <FormCheck.Label className={classes.checkBoxLabel}>
        {children}
      </FormCheck.Label>
    </FormCheck>
  );
};
